module.exports = __webpack_public_path__ + "img/Back-arrow.9df21487.svg";